// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3ybqa","fileBtn":"File_fileBtn__2jjjY","closeBtn":"File_closeBtn__3rn7B","fileSelected":"File_fileSelected__2MKPR","disabled":"File_disabled__zACg2"};